import { useTranslation } from '@/i18n/i18n';

export const KSeFHowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      number: '1',
      title: t('ksef.howItWorks.step1.title'),
      description: t('ksef.howItWorks.step1.desc'),
    },
    {
      number: '2',
      title: t('ksef.howItWorks.step2.title'),
      description: t('ksef.howItWorks.step2.desc'),
    },
    {
      number: '3',
      title: t('ksef.howItWorks.step3.title'),
      description: t('ksef.howItWorks.step3.desc'),
    },
  ];

  return (
    <section
      id="jak-to-dziala"
      aria-labelledby="ksef-how-it-works-heading"
      className="py-16 px-6 md:px-8 bg-card"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2
            id="ksef-how-it-works-heading"
            className="text-3xl md:text-5xl font-semibold mb-4 tracking-tight"
          >
            {t('ksef.howItWorks.heading')}
          </h2>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-8 left-[15%] right-[15%] h-0.5 bg-gradient-to-r from-primary/10 via-primary/40 to-primary/10" />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-6">
            {steps.map((step) => (
              <div key={step.number} className="relative group text-center">
                <div className="number-badge mx-auto mb-4 relative z-10 group-hover:scale-110 transition-transform duration-300">
                  {step.number}
                </div>
                <h3 className="text-lg font-semibold mb-2 text-foreground">{step.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
